import * as tslib_1 from "tslib";
import _ from 'lodash';
import { GenericErrorResponseCode, DefaultAccountDetails, } from '@tradingblock/types';
import { GetAccountsUrl, GetAccountDetailsUrl, AccountsSearchUrl, GetSubaccountsUrl, SearchAccountUpdatesUrl, GetAccountUpdateDetailsUrl, GetAccountManagementDetailsUrl, GetDocumentStatusUrl, } from '../constants';
import { getIdNumber } from '..';
import { dateStringOrUndefined } from '..';
const RequestHeaders = {
    headers: { Accept: 'application/json' },
};
export function accounts(api) {
    return {
        all: () => {
            return api.authenticated().get(GetAccountsUrl, {}, RequestHeaders);
        },
        get: (acctId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const accountId = getIdNumber(acctId);
                return yield api.authenticated().get(GetAccountsUrl, { accountId }, RequestHeaders);
            }
            catch (err) {
                console.warn('error requesting account by accountId', acctId);
                return {
                    responseCode: GenericErrorResponseCode,
                    payload: [],
                };
            }
        }),
        subaccounts: (acctId) => {
            const accountId = getIdNumber(acctId);
            return api.authenticated().get(GetSubaccountsUrl, { accountId }, RequestHeaders);
        },
        details: (acctId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const accountId = getIdNumber(acctId);
                return yield api.authenticated().get(GetAccountDetailsUrl, { accountId }, RequestHeaders);
            }
            catch (err) {
                console.warn('error requesting account details by accountId', acctId);
                return {
                    responseCode: GenericErrorResponseCode,
                    payload: DefaultAccountDetails,
                };
            }
        }),
        search: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const searchRequest = Object.assign({}, request);
            const result = yield api
                .authenticated()
                .get(AccountsSearchUrl, searchRequest, RequestHeaders);
            return result;
        }),
        update: (acctId, request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const holder = request.holder ? request.holder : 0;
            const result = yield api
                .authenticated()
                .put(`Accounts/UpdateAccount?accountId=${acctId}&holder=${holder}`, request, RequestHeaders);
            return result;
        }),
        getUpdate: (confirm) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield api.authenticated().get(`Accounts/GetAccountUpdate?confirm=${confirm}`, RequestHeaders);
        }),
        confirmUpdate: (confirm) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield api.authenticated().put(`Accounts/ConfirmAccountUpdate?confirm=${confirm}`, confirm, RequestHeaders);
        }),
        getUserUpdates: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const startDate = _.isNil(request.startDate) ? undefined : dateStringOrUndefined(request.startDate, 'YYYY-MM-DD');
            const endDate = _.isNil(request.endDate) ? undefined : dateStringOrUndefined(request.endDate, 'YYYY-MM-DD');
            const searchRequest = Object.assign({}, request, { endDate,
                startDate });
            return yield api.authenticated().get(SearchAccountUpdatesUrl, searchRequest, RequestHeaders);
        }),
        getUserUpdateDetails: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const updateRequest = {
                accountId: request.accountId,
                updateId: request.id,
            };
            return yield api.authenticated().get(GetAccountUpdateDetailsUrl, updateRequest, RequestHeaders);
        }),
        getUserAccountDetails: (accountId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield api.authenticated().get(GetAccountManagementDetailsUrl, accountId, RequestHeaders);
        }),
        firmApproveUpdate: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield api
                .authenticated()
                .put(`Accounts/FirmApproveAccountUpdate?accountId=${request.accountId}&updateId=${request.updateId}`, request.request, RequestHeaders);
        }),
        firmRejectUpdate: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield api
                .authenticated()
                .put(`Accounts/FirmRejectAccountUpdate?accountId=${request.accountId}&updateId=${request.updateId}`, request.request, RequestHeaders);
        }),
        entitlements: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield api.authenticated().get(`/User/GetEntitlements`, {}, RequestHeaders);
        }),
        getDocumentStatus: (accountId) => api.authenticated().get(GetDocumentStatusUrl, { accountId }, RequestHeaders),
    };
}
//# sourceMappingURL=account.js.map